import {
  AcceptedMessageDataToSubmitMessage,
  AcceptedMessageTypeToSubmitMessage,
} from '../../../../../../../../../contexts/chatSocket/hooks/useChatWebsocket/useChatWebsocket.types';
import { Message } from '../../../../../../../../../contexts/chatSocket/reducer/chatSocketReducer.types';
import { isVideoCallMessageType } from '../../../../../../../../../contexts/chatSocket/reducer/chatSocketReducer.utils';
import { useChatMessagesContext } from '../../../../../../../contexts/chatMessages.context';
import { ChatMessageItemProps } from '../chatMessageItem.types';

interface UseChatMessageItemParams {
  closeErrorListActions: () => void;
  onClickRetry: ChatMessageItemProps['onClickRetry'];
}

const useChatMessageItem = ({ closeErrorListActions, onClickRetry }: UseChatMessageItemParams) => {
  const { onClickRemove } = useChatMessagesContext();

  const handleClickListItem = (callback: () => void) => {
    callback();
    closeErrorListActions();
  };

  const handleClickRetry = (messageToRetry: Message) => {
    if (!messageToRetry.tempId || isVideoCallMessageType(messageToRetry)) {
      return;
    }

    // TODO: AJUSTAR TIPAGEM PARA N USAR as
    onClickRetry({
      body: messageToRetry.body,
      messageTemporaryId: messageToRetry.tempId,
      type: messageToRetry.type as AcceptedMessageTypeToSubmitMessage,
      data: messageToRetry.data as AcceptedMessageDataToSubmitMessage,
    });
  };

  const handleClickRemove = (messageToRemove: Message) => {
    if (!messageToRemove.tempId) {
      return;
    }
    onClickRemove(messageToRemove.tempId);
  };

  return {
    handleClickListItem,
    handleClickRetry,
    handleClickRemove,
  };
};

export default useChatMessageItem;
